import { Component, OnInit } from '@angular/core';
import { NotificationsService } from '@services/notifications.service';
import { TranslationService } from '@services/translation.service';
import { CourseImportService } from '@services/course-import.service';
import { EnvironmentService } from '@services/environment.service';
import { Router } from '@angular/router';
import { take } from 'rxjs';

@Component({
  selector: 'app-archive-import',
  templateUrl: './archive-import.component.html',
  styleUrl: './archive-import.component.scss',
  standalone: false,
})
export class ArchiveImportComponent implements OnInit {
  maxFileSize = 1073741824 * 10; //  10GB in bytes
  canUpload = false;
  errorMessage = null;
  refreshTrigger = 0;
  isBlackboard = false;

  customColumns: any[] = [
    {
      property: 'srcfolder',
      translationKey: 'source',
      text: 'Source',
      type: 'string',
      width: '200px',
    },
  ];
  constructor(
    private notificationService: NotificationsService,
    private translationService: TranslationService,
    private courseImportService: CourseImportService,
    private environmentService: EnvironmentService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.environmentService
      .getInstanceDetails()
      .pipe(take(1))
      .subscribe((details: any) => {
        if (details?.system_type === 'blackboard') {
          this.isBlackboard = true;
        } else {
          this.router.navigate(['/home']);
        }
      });
  }

  handleUploadStarted() {
    console.log('upload started');
  }

  handleFileUpload(event: any) {
    // Check if file is over set max file size
    const file = event?.[0];
    if (file) {
      if (file.size > this.maxFileSize) {
        this.errorMessage = this.translationService.getTranslatedContent(
          'file_size_exceeds_limit',
          'File size exceeds limit'
        );
        this.notificationService.popNotification('', this.errorMessage);
        this.canUpload = false;
        return;
      } else {
        this.canUpload = true;
        this.errorMessage = null;
      }
    } else {
      this.canUpload = false;
      this.errorMessage = this.translationService.getTranslatedContent(
        'no_file_selected',
        'No file selected'
      );
      this.notificationService.popNotification('', this.errorMessage);
    }
  }

  handleUploadComplete(event: any) {
    let file = null;
    try {
      if (!event || !event[0] || !event[0].name) {
        throw new Error('No file found in upload complete event');
      }
      file = event[0].name;
      if (!file) {
        throw new Error('No file found in upload complete event');
      }
    } catch (err) {
      this.errorMessage = this.translationService.getTranslatedContent(
        'upload_complete_error',
        'An error occurred during upload.'
      );
      this.notificationService.popNotification('', this.errorMessage);
      return;
    }
    this.notificationService.popNotification(
      '',
      this.translationService.getTranslatedContent(
        'upload_complete_starting_import',
        'Upload complete, starting import for file ' + file + '...'
      )
    );
    this.courseImportService.importArchive({ file: file }).subscribe({
      next: data => {
        this.refreshTrigger++;
      },
      error: err => {
        this.errorMessage = this.translationService.getTranslatedContent(
          'import_failed',
          'Import failed'
        );
        this.notificationService.popNotification('', this.errorMessage);
        this.refreshTrigger++;
      },
    });
  }
}
